const closeButtonLabel = "Κλείσιμο";
const elGR = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  elGR as default
};
